module.exports = __webpack_public_path__ + "img/logo.d2d39c79.svg";